import React, { memo, useMemo } from 'react'

import { Button, Icon, Search, ImageAdd, Edit } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import { setImageAssistantTab } from 'Pods/ThreeDStudio/Store/actions/ui'
import { IMAGE_ASSISTANT_TAB } from 'Pods/ThreeDStudio/Store/constants'

const TAB_DEFS = [
  { id: IMAGE_ASSISTANT_TAB.SEARCH, label: 'Search', icon: Search },
  { id: IMAGE_ASSISTANT_TAB.CREATE, label: 'Create', icon: ImageAdd },
  { id: IMAGE_ASSISTANT_TAB.EDIT, label: 'Edit', icon: Edit },
]

function Tabs({ activeTab }) {
  const buttons = useMemo(() => TAB_DEFS.map(tab => ({
    ...tab,
    onClick: () => setImageAssistantTab(tab.id),
  })), [])

  return (
    <div className="image-assistant-panel__tabs">
      {buttons.map(({ id, label, icon, onClick }) => (
        <Button
          key={id}
          type="secondary"
          variant="with-icon"
          size="tiny"
          expand
          customClass="image-assistant-panel__tab"
          isActive={activeTab === id}
          onClick={onClick}
        >
          <span className="image-assistant-panel__tab-content">
            <Icon svgComponent={icon} color="darker" size={iconSize} notSpaced />
            {label}
          </span>
        </Button>
      ))}
    </div>
  )
}

Tabs.propTypes = {
  activeTab: string.isRequired,
}

export default memo(Tabs)
